// project
import * as C from "@/components.home/home";

export const HomeView = {
	path: "/home",
	name: "home",
	component: C.Home,
	meta: {
		title: "Home"
	},
};